import { FC, ReactElement, useEffect } from 'react';
import { useQuery } from 'react-query';

import { useActions } from '../hooks/useActions';
import { userActions } from '../store/user/user.slice';
import { UserService } from '../service/user/user.service';
import { setStoreLocal } from '../utils/local-storage';
import { AuthService } from '../service/auth/auth.service';
import { useAppDispatch } from '../hooks/redux';
import { Basket } from '../Modules/Basket';

const DataProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const { fetchMainCatalog, getProfile, checkAuthAndGetprofile, checkAuth } = useActions();
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchMainCatalog(); //Вызов каталога
    setStoreLocal('city_value', {
      city: 'г. Владивосток',
      street: 'ул. Дальзоводская, 4, пав. 310',
      phone: '+7 (423) 246-48-64',
    });
  }, []);

  return <>{children}</>;
};

export default DataProvider;
